import * as api from "./api";

const COMMON_ERROR = "Error, Please try again.!";
const errorResponse = (error) => {
    if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
            localStorage.clear();
            window.location.href = "/";
            window.location.reload();
            window.location.href = '/'
        };
        if (status === 403) {
            localStorage.clear();
            window.location.reload();
            window.location.href = '/'
        };
        return data;
    } else {
        return { status: 0, message: COMMON_ERROR };
    };
};


let setFormData = (_payload) => {
    let formData = new FormData();
    for (let key in _payload) {
        if ((key === "bigPreviewStickerStore" || key === "stickerPreview" || key === "tag" || key === "videoPreview" ||
            key === "video" ||
            key === "faqImages" || key === "themeBigPreview") && _payload[key] && Array.isArray(_payload[key])) {
            _payload[key]?.forEach((_item) => formData?.append(`${key}`, _item))
        } else if (key === "media" || key === "oldMedia") {
            _payload[key]?.forEach((_item, i) => {
                Object.keys(_item).forEach((_ele) => {
                    formData?.append(`${key}[${i}][${_ele}]`, _item[_ele]);
                });
            });
        } else {
            formData?.append(`${key}`, _payload[key]);
        };
    };
    return formData;
};

export const check_user_permissions = async () => {
    try {
        const { data } = await api.checkUserPermissions(process.env.REACT_APP_PROJECT_ID);
        return data;
    } catch (error) {
        console.error(`checkuserpermissions =======>>>>> : ${error}`, error);
        return errorResponse(error);
    }
}

// SIGNIN ACTIONS
export const admin_signin = async (_payload) => {
    try {
        const { data } = await api.adminSignin(_payload);
        return data;
    } catch (error) {
        console.error(`admin_signin ====>>>> : ${error}`, error);
        return errorResponse(error);
    };
};

export const ldap_admin_signin = async (_payload) => {
    try {
        const { data } = await api.ldapadminSignin(_payload);
        return data;
    } catch (error) {
        console.error(`ldap_admin_signin ====>>>> : ${error}`, error);
        return errorResponse(error);
    }
}


// MUSIC ACTIONS
export const add_music_data = async (_payload) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.addMusic(formData);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const update_music = async (_payload, _id) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.updateMusic(formData, _id);
        return data;
    } catch (error) {
        console.error('error====>>>> ', error);
        return errorResponse(error);
    };
};

export const update_Music_Priority = async (_payload) => {
    try {
        const { data } = await api.updateMusicPriority(_payload);
        return data;
    } catch (error) {
        console.error('error====>>>> ', error);
        return errorResponse(error);
    };
};

export const delete_music = async (_id) => {
    try {
        const { data } = await api.deleteMusic(_id);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_all_music = async (_payload) => {
    try {
        const { data } = await api.deleteAllMusic(_payload);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const get_music_data = async (_search, _filterDropdown, sortName, sortType) => {
    try {
        let galleryMusicData;
        // if (_currentPage || _perPage || _search || _filterDropdown) {
        if (_search || _filterDropdown || sortName || sortType) {
            // const { data } = await api.getMusic(_currentPage, _perPage, _search, _filterDropdown);
            const { data } = await api.getMusic(_search, _filterDropdown, sortName, sortType);
            galleryMusicData = data;
        } else {
            const { data } = await api.getMusic();
            galleryMusicData = data;
        }
        return galleryMusicData;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};

// Stickers ACTIONS
export const add_sticker_data = async (_payload) => {
    try {
        let formData = setFormData(_payload);
        
        const { data } = await api.addStickers(formData);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const update_sticker = async (_payload, _id) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.updateStickers(formData, _id);
        return data;
    } catch (error) {
        console.error('error====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_sticker = async (_id) => {
    try {
        const { data } = await api.deleteStickers(_id);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_all_sticker = async (_payload) => {
    try {
        const { data } = await api.deleteAllStickers(_payload);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const get_sticker_data = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType) => {
    try {
        let galleryStickerData;
        if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType) {
            const { data } = await api.getStickers(_currentPage, _perPage, _search, _filterDropdown, sortName, sortType);
            galleryStickerData = data;
        } else {
            const { data } = await api.getStickers();
            galleryStickerData = data;
        }
        return galleryStickerData;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};


// Stickers Tag ACTIONS
export const add_sticker_Tags = async (_payload) => {
    try {
        const { data } = await api.addStickerTags(_payload);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const update_sticker_Tags = async (_payload, _id) => {
    try {
        const { data } = await api.updateStickerTags(_payload, _id);
        return data;
    } catch (error) {
        console.error('error====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_sticker_Tags = async (_id) => {
    try {
        const { data } = await api.deleteStickerTags(_id);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_all_sticker_Tags = async (_payload) => {
    try {
        const { data } = await api.deleteAllStickerTags(_payload);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const get_sticker_Tags = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType) => {
    try {
        let galleryData;
        if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType) {
            const { data } = await api.getStickerTags(_currentPage, _perPage, _search, _filterDropdown, sortName, sortType);
            galleryData = data;
        } else {
            const { data } = await api.getStickerTags();
            galleryData = data;
        }
        return galleryData;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};


// feedback ACTIONS
export const add_feedback = async (_payload) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.addFeedback(formData);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const update_feedback = async (_payload, _id) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.updateFeedback(formData, _id);
        return data;
    } catch (error) {
        console.error('error====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_feedback = async (_id) => {
    try {
        const { data } = await api.deleteFeedback(_id);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_all_feedback = async (_payload) => {
    try {
        const { data } = await api.deleteAllFeedback(_payload);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const get_feedback = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType, startDate, endDate) => {
    try {
        let galleryData;
        if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType || startDate || endDate) {
            const { data } = await api.getFeedback(_currentPage, _perPage, _search, _filterDropdown, sortName, sortType, startDate, endDate);
            galleryData = data;
        } else {
            const { data } = await api.getFeedback();
            galleryData = data;
        }
        return galleryData;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const download_feedback_excel = async (_filterDropdown, _search, startDate, endDate) => {
    try {
        let galleryData;
        if (_filterDropdown || _search || startDate || endDate) {
            const { data } = await api.downloadFeedbackExcel(_filterDropdown, _search, startDate, endDate);
            galleryData = data;
        } else {
            const { data } = await api.downloadFeedbackExcel();
            galleryData = data;
        }

        return galleryData;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    }
}
export const get_feedback_DropDownList = async () => {
    try {
        const { data } = await api.getFeedbackDropDownList();
        let galleryData = data;
        return galleryData;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};

// userFeedbackData
export const get_user_feedback = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType, startDate, endDate) => {
    try {
        let galleryData;
        if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType || startDate || endDate) {
            const { data } = await api.getUserFeedback(_currentPage, _perPage, _search, _filterDropdown, sortName, sortType, startDate, endDate);
            galleryData = data;
        } else {
            const { data } = await api.getUserFeedback();
            galleryData = data;
        }
        return galleryData;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};

// Rating ACTIONS
export const add_Rating = async (_payload) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.addRating(formData);
        return data;
    } catch (error) {
        console.error('Rating====> ', error);
        return errorResponse(error);
    };
};
export const update_Rating = async (_payload, _id) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.updateRating(formData, _id);
        return data;
    } catch (error) {
        console.error('error====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_Rating = async (_id) => {
    try {
        const { data } = await api.deleteRating(_id);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_all_Rating = async (_payload) => {
    try {
        const { data } = await api.deleteAllRating(_payload);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const get_Rating = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType, startDate, endDate) => {
    try {
        let galleryData;
        if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType || startDate || endDate) {
            const { data } = await api.getRating(_currentPage, _perPage, _search, _filterDropdown, sortName, sortType, startDate, endDate);
            galleryData = data;
        } else {
            const { data } = await api.getRating();
            galleryData = data;
        }
        return galleryData;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};

export const download_rating_excel = async (_filterDropdown, _search, startDate, endDate) => {
    try {
        let galleryData;
        if (_filterDropdown || _search || startDate || endDate) {
            const { data } = await api.downloadRatingExcel(_filterDropdown, _search, startDate, endDate);
            galleryData = data;
        } else {
            const { data } = await api.downloadRatingExcel();
            galleryData = data;
        }

        return galleryData;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    }
}
export const get_Rating_DropDownList = async () => {
    try {
        const { data } = await api.getRatingDropDownList();
        let ratingData = data;
        return ratingData;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};


// Feedback Category
export const add_FeedbackCategory = async (_payload) => {
    try {
        const { data } = await api.addFeedbackCategory(_payload);
        return data;
    } catch (error) {
        console.error('Rating====> ', error);
        return errorResponse(error);
    };
};
export const update_FeedbackCategory = async (_payload, _id) => {
    try {
        const { data } = await api.updateFeedbackCategory(_payload, _id);
        return data;
    } catch (error) {
        console.error('error====>>>> ', error);
        return errorResponse(error);
    };
};

export const update_FeedbackCategory_Priority = async (_payload) => {
    try {
        const { data } = await api.updateFeedbackCategoryPriority(_payload);
        return data;
    } catch (error) {
        console.error('error====>>>> ', error);
        return errorResponse(error);
    };
};

export const delete_FeedbackCategory = async (_id) => {
    try {
        const { data } = await api.deleteFeedbackCategory(_id);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_all_FeedbackCategory = async (_payload) => {
    try {
        const { data } = await api.deleteAllFeedbackCategory(_payload);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const get_FeedbackCategory = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType) => {
    try {
        let galleryData;
        if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType) {
            const { data } = await api.getFeedbackCategory(_currentPage, _perPage, _search, _filterDropdown, sortName, sortType);
            galleryData = data;
        } else {
            const { data } = await api.getFeedbackCategory();
            galleryData = data;
        }
        return galleryData;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const update_Feedbackcategory_Setting = async (_payload) => {
    try {
        const { data } = await api.updateFeedbackCategorySetting(_payload);
        let jsondata = data?.data
        return jsondata;
    } catch (error) {
        console.error('Rating====> ', error);
        return errorResponse(error);
    };
};

export const get_Feedbackcategory_Setting = async () => {
    try {
        let getFeedbackcategoryData;
        const { data } = await api.getFeedbackCategorySetting();
        getFeedbackcategoryData = data;
        return getFeedbackcategoryData;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};

// Feedback Sub Category
export const add_Feedback_Sub_Category = async (_payload) => {
    try {
        const { data } = await api.addFeedbackSubCategory(_payload);
        return data;
    } catch (error) {
        console.error('Rating====> ', error);
        return errorResponse(error);
    };
};
export const update_Feedback_Sub_Category = async (_payload, _id) => {
    try {
        const { data } = await api.updateFeedbackSubCategory(_payload, _id);
        return data;
    } catch (error) {
        console.error('error====>>>> ', error);
        return errorResponse(error);
    };
};
export const update_Feedback_Sub_Priority = async (_payload) => {
    try {
        const { data } = await api.updateFeedbackSubCategoryPriority(_payload);
        return data;
    } catch (error) {
        console.error('error====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_Feedback_Sub_Category = async (_id) => {
    try {
        const { data } = await api.deleteFeedbackSubCategory(_id);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_all_Feedback_Sub_Category = async (_payload) => {
    try {
        const { data } = await api.deleteAllFeedbackSubCategory(_payload);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const get_Feedback_Sub_Category = async (_payload) => {
    try {
        // if (_currentPage || _perPage || _search || _filterDropdown) {
        //     const { data } = await api.getFeedbackSubCategory(_currentPage, _perPage, _search, _filterDropdown);
        //     galleryData = data;
        // } else {
        const { data } = await api.getFeedbackSubCategory(_payload);
        // }
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};

//Blogs 
export const get__Blog = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType) => {
    try {
        let blogData;
        if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType) {
            const { data } = await api.get_Blog(_currentPage, _perPage, _search, _filterDropdown, sortName, sortType);
            blogData = data;
        } else {
            const { data } = await api.get_Blog();
            blogData = data;
        }
        return blogData;
    } catch (error) {
        return errorResponse(error);
    };
};
export const update__Blog = async (_payload, _id) => {
    try {
        let formData;
        if (_payload.blogPreview) {
            formData = setFormData(_payload);
        } else {
            formData = _payload;
        }
        const { data } = await api.update_Blog(formData, _id);
        return data;
    } catch (error) {
        return errorResponse(error);
    };
};
export const getOne__Blog = async (_id) => {
    try {
        const { data } = await api.getOne_Blog(_id);
        return data;
    } catch (error) {
        console.error('getOne_Blog ====>>>> ', error);
        return errorResponse(error);
    };
};
export const add__Blog = async (_payload) => {
    try {
        const formData = setFormData(_payload);
        const { data } = await api.add_Blog(formData);
        return data;
    } catch (error) {
        return errorResponse(error);
    };
};
export const delete__Blog = async (_id) => {
    try {
        const { data } = await api.delete_Blog(_id);
        return data;
    } catch (error) {
        return errorResponse(error);
    };
};
export const deleteAll__Blog = async (_payload) => {
    try {
        const { data } = await api.deleteAll_Blog(_payload);
        return data;
    } catch (error) {
        return errorResponse(error);
    };
};

//Blogs categories
export const get__Blog_categories = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType) => {
    try {
        let CommunityData;
        if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType) {
            const { data } = await api.get_Blog_categories(_currentPage, _perPage, _search, _filterDropdown, sortName, sortType);
            CommunityData = data;
        } else {
            const { data } = await api.get_Blog_categories();
            CommunityData = data;
        }
        return CommunityData;
    } catch (error) {
        return errorResponse(error);
    };
};
export const update__Blog_categories = async (_payload, _id) => {
    try {
        const { data } = await api.update_Blog_categories(_payload, _id);
        return data;
    } catch (error) {
        return errorResponse(error);
    };
};
export const add__Blog_categories = async (_payload) => {
    try {
        const { data } = await api.add_Blog_categories(_payload);
        return data;
    } catch (error) {
        return errorResponse(error);
    };
};
export const delete__Blog_categories = async (_id) => {
    try {
        const { data } = await api.delete_Blog_categories(_id);
        return data;
    } catch (error) {
        return errorResponse(error);
    };
};
export const deleteAll__Blog_categories = async (_payload) => {
    try {
        const { data } = await api.deleteAll_Blog_categories(_payload);
        return data;
    } catch (error) {
        return errorResponse(error);
    };
};

//Blogs Comments
export const get__Blog_Comments = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType) => {
    try {
        let CommunityData;
        if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType) {
            const { data } = await api.get_Blog_Comments(_currentPage, _perPage, _search, _filterDropdown, sortName, sortType);
            CommunityData = data;
        } else {
            const { data } = await api.get_Blog_Comments();
            CommunityData = data;
        }
        return CommunityData;
    } catch (error) {
        return errorResponse(error);
    };
};
export const delete__Reply = async (_id) => {
    try {
        const { data } = await api.delete_Reply(_id);
        return data;
    } catch (error) {
        return errorResponse(error);
    };
};
export const deleteAll__Reply = async (_payload) => {
    try {
        const { data } = await api.deleteAll_Reply(_payload);
        return data;
    } catch (error) {
        return errorResponse(error);
    };
};

export const add_subscription_data = async (_payload) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.addSubscriptions(formData);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const get_subscription_data = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType) => {
    try {
        let galleryStickerData;
        if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType) {
            const { data } = await api.getSubscriptions(_currentPage, _perPage, _search, _filterDropdown, sortName, sortType);
            galleryStickerData = data;
        } else {
            const { data } = await api.getSubscriptions();
            galleryStickerData = data;
        }
        return galleryStickerData;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_subscription = async (_id) => {
    try {
        const { data } = await api.deleteSubscription(_id);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};

//FAQ
export const add_faq = async (_payload) => {
    try {
        const formData = setFormData(_payload);
        const { data } = await api.addFAQ(formData);
        return data;
    } catch (error) {
        return errorResponse(error);
    }
};

export const update_faq = async (_payload, _id) => {
    try {
        let formData;
        if (_payload.media) {
            formData = setFormData(_payload);
        } else {
            formData = _payload;
        }
        const { data } = await api.updateFAQ(formData, _id);
        return data;
    } catch (error) {
        return errorResponse(error);
    }
};

export const get_faq = async (_filterDropdown) => {
    try {
        let CommunityData;
        if (_filterDropdown) {
            const { data } = await api.getFAQ(_filterDropdown);
            CommunityData = data
        } else {
            const { data } = await api.getFAQ();
            CommunityData = data
        }
        return CommunityData;
    } catch (error) {
        return errorResponse(error);
    }
};

export const get_one_faq = async (_id) => {
    try {
        const { data } = await api.getOneFAQ(_id);
        return data;
    } catch (error) {
        return errorResponse(error);
    }
};

export const delete_faq = async (_id) => {
    try {
        const { data } = await api.deleteFAQ(_id);
        return data;
    } catch (error) {
        return errorResponse(error);
    }
};

export const delete_media_faq = async (_payload) => {
    try {
        const { data } = await api.deleteMediaFAQ(_payload);
        return data;
    } catch (error) {
        return errorResponse(error);
    }
};

export const update_faq_priority = async (_payload) => {
    try {
        const { data } = await api.updateFaqPriority(_payload);
        return data;
    } catch (error) {
        return errorResponse(error);
    }
};

export const updateFaq_media_priority = async (_payload) => {
    try {
        const { data } = await api.updateFaqMediaPriority(_payload);
        return data;
    } catch (error) {
        return errorResponse(error);
    }
};

// asset
export const add_asset = async (_payload) => {
    try {
        const { data } = await api.addAsset(_payload);
        return data;
    } catch (error) {
        return errorResponse(error);
    }
};

export const get_asset = async (_currentPage,
    _perPage,) => {
    try {
        let CommunityData;

        if (_currentPage || _perPage) {
            const { data } = await api.getAsset(
                _currentPage,
                _perPage,
            );
            CommunityData = data;
        } else {
            const { data } = await api.getAsset();
            CommunityData = data
        }
        return CommunityData;
    } catch (error) {
        return errorResponse(error);
    }
};

export const update_asset = async (_payload, _id) => {
    try {
        const { data } = await api.updateAsset(_payload, _id);
        return data;
    } catch (error) {
        return errorResponse(error);
    }
};

export const delete_asset = async (_id) => {
    try {
        const { data } = await api.deleteAsset(_id);
        return data;
    } catch (error) {
        return errorResponse(error);
    }
};

export const get_asset_link = async () => {
    try {
        let CommunityData;
        const { data } = await api.getAssetLink();
        CommunityData = data
        return CommunityData;
    } catch (error) {
        return errorResponse(error);
    }
};


export const get_encoding_string = async (_payload) => {
    try {
        const { data } = await api.getEncodingString(_payload);
        return data;
    } catch (error) {
        return errorResponse(error);
    }
};
//  Bank Regex

export const add_bank_data = async (_payload) => {
    try {
        const { data } = await api.addBankDetail(_payload);

        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};

// export const get_bank_regex = async (_payload) => {
//     try {
//         const { data } = await api.getBankRegex(_payload);
//         return data;
//     } catch (error) {
//         return errorResponse(error);
//     }
// };

export const get_bank_regex = async (_currentPage, _perPage, _search, sortName, sortType) => {
    try {
        let galleryData;
        if (_currentPage || _perPage || _search || sortName || sortType) {
            const { data } = await api.getBankRegex(_currentPage, _perPage, _search, sortName, sortType);
            galleryData = data;
        } else {
            const { data } = await api.getBankRegex();
            galleryData = data;
        }
        return galleryData;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};

export const update_bank_regex = async (_payload, _id) => {
    try {
        const { data } = await api.updateRegex(_payload, _id);
        return data;
    } catch (error) {
        return errorResponse(error);
    }
};

export const delete_bank_regex = async (_id) => {
    try {
        const { data } = await api.deleteBankRegex(_id);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};

// SMS Regex

export const add_bank_regex = async (_payload) => {
    try {
        const { data } = await api.addBankRegex(_payload);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};

// export const get_sms_regex = async (_payload) => {
//     try {
//         const { data } = await api.getSmsRegex(_payload);
//         return data;
//     } catch (error) {
//         return errorResponse(error);
//     }
// };

export const get_sms_regex = async (_currentPage, _perPage, _search, sortName, sortType) => {
    try {
        let galleryData;
        if (_currentPage || _perPage || _search || sortName || sortType) {
            const { data } = await api.getSmsRegex(_currentPage, _perPage, _search, sortName, sortType);
            galleryData = data;
        } else {
            const { data } = await api.getSmsRegex();
            galleryData = data;
        }
        return galleryData;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};

export const update_sms_regex = async (_payload, _id) => {
    try {
        const { data } = await api.updateSmsRegex(_payload, _id);
        return data;
    } catch (error) {
        return errorResponse(error);
    }
};

export const delete_sms_regex = async (_id) => {
    try {
        const { data } = await api.deleteSmsRegex(_id);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
// API Response
export const get_bank_data = async (_payload, countryCode) => {
    try {
        const { data } = await api.getBankData(_payload, countryCode = _payload?.countryCode);
        return data;
    } catch (error) {
        return errorResponse(error);
    }
};




// themes wallpaper
export const add_wallpaper_data = async (_payload) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.addWallpapers(formData);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const update_wallpaper = async (_payload, _id) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.updateWallpapers(formData, _id);
        return data;
    } catch (error) {
        console.error('error====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_wallpaper = async (_id) => {
    try {
        const { data } = await api.deleteWallpapers(_id);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_all_wallpaper = async (_payload) => {
    try {
        const { data } = await api.deleteAllWallpapers(_payload);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const get_wallpapers = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType) => {
    try {
        let avatarData;
        if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType) {
            const { data, status } = await api.getWallpapers(_currentPage, _perPage, _search, _filterDropdown, sortName, sortType);
            avatarData = data;
        } else {
            const { data, status } = await api.getWallpapers();
            avatarData = data;
        }
        return avatarData;
    } catch (error) {

        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
}
export const update_wallpaper_priority = async (_payload) => {
    try {
        const { data } = await api.updateWallpaperPriority(_payload);
        return data;
    } catch (error) {
        return errorResponse(error);
    }
};


// themes Bubble
export const add_bubble_data = async (_payload) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.addBubbles(formData);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const update_bubble = async (_payload, _id) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.updateBubbles(formData, _id);
        return data;
    } catch (error) {
        console.error('error====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_bubble = async (_id) => {
    try {
        const { data } = await api.deleteBubbles(_id);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_all_bubble = async (_payload) => {
    try {
        const { data } = await api.deleteAllBubbles(_payload);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const get_bubble = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType) => {
    try {
        let avatarData;
        if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType) {
            const { data, status } = await api.getBubbles(_currentPage, _perPage, _search, _filterDropdown, sortName, sortType);
            avatarData = data;
        } else {
            const { data, status } = await api.getBubbles();
            avatarData = data;
        }
        return avatarData;
    } catch (error) {

        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
}
export const update_bubble_priority = async (_payload) => {
    try {
        const { data } = await api.updateBubblePriority(_payload);
        return data;
    } catch (error) {
        return errorResponse(error);
    }
};




// themes Font
export const add_font_data = async (_payload) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.addFont(formData);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const update_font = async (_payload, _id) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.updateFont(formData, _id);
        return data;
    } catch (error) {
        console.error('error====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_font = async (_id) => {
    try {
        const { data } = await api.deleteFont(_id);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_all_font = async (_payload) => {
    try {
        const { data } = await api.deleteAllFont(_payload);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};

export const get_font_data = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType) => {
    try {
        let avatarData;
        if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType) {
            const { data, status } = await api.getFont(_currentPage, _perPage, _search, _filterDropdown, sortName, sortType);
            avatarData = data;
        } else {
            const { data, status } = await api.getFont();
            avatarData = data;
        }
        return avatarData;
    } catch (error) {

        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
}
export const update_font_priority = async (_payload) => {
    try {
        const { data } = await api.updateFontPriority(_payload);
        return data;
    } catch (error) {
        return errorResponse(error);
    }
};







// themes 
export const add_themes_data = async (_payload) => {
    try {
        let formData = setFormData(_payload);
        console.log('formData: ', formData);
        const { data } = await api.addThemes(formData);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};


export const update_themes = async (_payload, _id) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.updateThemes(formData, _id);
        return data;
    } catch (error) {
        console.error('error====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_themes = async (_id) => {
    try {
        const { data } = await api.deleteThemes(_id);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_all_themes = async (_payload) => {
    try {
        const { data } = await api.deleteAllThemes(_payload);
        return data;
    } catch (error) {
        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
};
export const get_themes = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType) => {
    try {
        let avatarData;
        if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType) {
            const { data, status } = await api.getThemes(_currentPage, _perPage, _search, _filterDropdown, sortName, sortType);
            avatarData = data;
        } else {
            const { data, status } = await api.getThemes();
            avatarData = data;
        }
        return avatarData;
    } catch (error) {

        console.error('error ====>>>> ', error);
        return errorResponse(error);
    };
}
export const update_themes_priority = async (_payload) => {
    try {
        const { data } = await api.updateThemesPriority(_payload);
        return data;
    } catch (error) {
        return errorResponse(error);
    }
};
